import { VTO_TYPES } from '../../constants';
import moment from "moment";
import { getRequestTypeList } from '../../Enums/Helpers/LabellingHelper';
import { currentHttpOptions } from '../../utils';
import axios from 'axios';

/**
 * Indexed dictionary for `N` elements of the given type 
 * @template T
 * @typedef {{
*  [key: string|number]: T[]
* }} DictionaryOfListType
*/

/**
* @typedef {DictionaryOfListType<ApiManager.OpenShiftsByWorkRulePresentationModel>} OpenShiftOptionsDictionary
* @typedef {DictionaryOfListType<ApiManager.OpenShiftsByWorkRulePresentationModel>} LocationOptionsListDictionary
* @typedef {{
*  openShiftOptions: OpenShiftOptionsDictionary;
*  locationOptionsList: LocationOptionsListDictionary;
* }} OpenShiftOptions
* 
* @typedef {{
*  startDate: string;
*  endDate: string;
*  workRuleIds: number[];
*  locationIds: number[];
* }} OpenShiftOptionsParams
*/

export const initialState = {
    showButtons: false,
    name: '',
    description: '',
    details: '',
    autoApproval: true,
    editMode: false,
    errorHypefind: true,
    hyperFindQuery: '',
    requestType: '',
    hyperfindSettings: [],
    setting: '',
    requestLocations: [],
    location: [],
    locationNodes: {},
    locationEffectiveDate: null,
    requestPeriodSelected: {
        startDate: moment(),
        endDate: moment(),
        label: '',
        singleLabel: '',
        forever: false,
    },
    coverPeriodSelected: {
        startDate: moment(),
        endDate: moment(),
        label: '',
        forever: false,
    },
    // prevState: '', // In the constructor of the class.
    workrules: {
        included: [],
        excluded: [],
    },
    selectedHyperfindRatios: [],
    maximumVtoCount: null,
    isBlockDays: false,
    isSubmitable: false,
    isFullyEditable: false,
    vtoTypes: [...VTO_TYPES],
    timePeriodRatioOptions: [],
    selectedTimePeriodRatioOption: null,
    multiSingleDates: [],
    step1Errors: false,
    hyperfindRatioErrors: false,
    openShiftOptions: [],
    selectedOpenShifts: [],
    locationOptionsList: [],
    isAllOpenShiftEnabled: false,
    isRequestPeriodLimitsEnabled: false,
    requestPeriodLimitInDays: null,
    isHideRequestsOutsideRequestPeriod: false,
};

/**
 * The "hide open shifts outside request period" option only exists alongside a request period limit,
 * so it is dropped whenever no limit applies.
 * @param {number|null|undefined} requestPeriodLimitInDays
 * @param {boolean} isHideRequestsOutsideRequestPeriod
 * @returns {boolean}
 */
export const resolveHideRequestsOutsideRequestPeriod = (requestPeriodLimitInDays, isHideRequestsOutsideRequestPeriod) =>
    !requestPeriodLimitInDays ? false : !!isHideRequestsOutsideRequestPeriod;



/**
* @param {OpenShiftOptionsParams} params
* @returns {Promise<OpenShiftOptions>}
*/
export const getOpenShiftOptions = async (params) => {
    const options = currentHttpOptions();
    const queryStringParams = queryStringBuilder(params);

    const url = `${rootForV1API}/OpenShift/GetOpenShifts?${queryStringParams}`;

    /** @type {[DictionaryOfListType<OpenShiftOptionsDictionary>, OpenShiftOptionsDictionary]} */
    const openShiftOptions = await axios.get(url, options);

    return {
        openShiftOptions: openShiftOptions || [],
    };
}

export const requestTypeList = getRequestTypeList();
export const rootForV1API = `${process.env.REACT_APP_API_DOTNET}/api/v1`;

/**
 * @param {Object} params 
 */
export const queryStringBuilder = (params) => {
    const stringifyWhenArray = (v) => Array.isArray(v) ? JSON.stringify(v) : v;

    return Object
        .entries(params)
        .map(([key, value]) => `${key}=${stringifyWhenArray(value)}`)
        .join('&');
}

/**
 * 
 * @param {ConfigurationSet.IConfigurationSet[]} settingList
 * @param {number} id 
 */
export const isSettingArchived = (settingList, id) => {
    return settingList.find(x => x.id === id)?.isArchive;
}

const defaultHyperfindSettingProps = {
    markedForDeletion: false,
    isNew: false,
}

/**
 * @template T
 * @param {boolean} isDuplicate 
 * @param {T} settingList 
 * @returns {(x: T) => T & typeof defaultHyperfindSettingProps}
 */
export const transformHyperfindSettingsToModel = (isDuplicate, settingList) => (x) => {
    const adminSettingIdProp = isDuplicate && isSettingArchived(settingList, x.adminSettingsId)
        ? { adminSettingsId: undefined } : null;

    return {
        ...x,
        ...defaultHyperfindSettingProps,
        ...adminSettingIdProp,
    }

}